import { FC } from 'react';

import RouterLink, { RouterLinkProps } from 'app/components/shared/RouterLink';

import Box from '../Box';
import Button, { ButtonProps } from '../Button';

// Local Typings
interface ButtonPropsWithLabel extends Omit<ButtonProps, 'children'> {
  label: string;
}
interface BannerButtonProps {
  props: ButtonPropsWithLabel;
  type: 'button';
}
interface BannerLinkProps {
  props: RouterLinkProps & { label: string };
  type: 'link';
}

export type BannerSecondaryElementProps =
  | BannerButtonProps
  | BannerLinkProps;

// Component Definition
const BannerSecondaryElement: FC<BannerSecondaryElementProps> = ({
  props,
  type,
}) => {
  switch (type) {
    case 'button':
      return (
        <Box
          alignItems="flex-start"
          alignSelf="stretch"
          className="notification_banner-secondary-element"
          display="flex"
          marginLeft={4}
        >
          <Button
            buttonSize="sm"
            hierarchy="tertiary"
            {...props}
          >
            {props.label}
          </Button>
        </Box>
      );
    case 'link':
      return (
        <Box
          alignItems="flex-start"
          alignSelf="stretch"
          className="notification_banner-secondary-element"
          display="flex"
          flexShrink={0}
          marginLeft={4}
        >
          <RouterLink
            fontSize="smallBody"
            {...props}
          >
            {props.label}
          </RouterLink>
        </Box>
      );
  }
};

export default BannerSecondaryElement;
